import accordion from "./modules/accordion";
import breadcrumb from "./modules/breadcrumb";
import dataTablesInit from "./modules/dataTablesInit";
import dropdown from "./modules/dropdown";
import inlineFunctions from "./modules/inlineFunctions";
import inputToogleActive from "./modules/inputToogleActive";
import multiLevelMenu from "./modules/multiLevelMenu";
import showCorrectSection from "./modules/showCorrectSection";
import showToast from "./modules/showToast";
import startAllChoices from "./modules/startAllChoices";
import tabs from "./modules/tabs";
import mostraSenha from "./modules/mostraSenha";
import tableSelecionarColunas from "./modules/tableSelecionarColunas.js";
import tableBasicOrdenation from "./modules/tableBasicOrdenation.js";
import addFilterURLAndReload from "./modules/addFilterURLAndReload.js";
import tableBasicSearch from "./modules/tableBasicSearch.js";
import tableBasicQnt from "./modules/tableBasicQnt.js";
import tableBasicRecentes from "./modules/tableBasicRecentes.js";
import badge from "./modules/badge.js";
// import modalFiltrar from './modules/modalFiltrar.js'
import FilepondCardsCreatorWrapper from "./modules/FilepondCardsCreator.js";
import mutationForm from "./modules/mutationForm.js";
import initMenuMobile from "./modules/menuMobile.js";
import submitOnChange from "./modules/submitOnChange.js";
import inputLogin from "./modules/inputLogin.js";
import dataMasks from "./modules/dataMasks.js";
import initConditionalLink from "./modules/initConditionalLink";
import "./modules/notificacoes.js";

dataTablesInit();
accordion();
breadcrumb();
dropdown();
inlineFunctions(); // Faz as implementações relacionadas aos inlines
inputToogleActive(); // muda class ativa nos inputs
multiLevelMenu()
showCorrectSection(); //mostra elemento de acordo com parametro na url
showToast();
startAllChoices(); //inicia bibiloteca Choices.js
tabs();
badge();
mostraSenha();
addFilterURLAndReload(); //adiona um filtro na url e recarrega
//table
tableSelecionarColunas(); //show hide coluns
tableBasicOrdenation(); // ordenacao ao clicar na thead
tableBasicSearch(); //Busca da tabela basica
tableBasicQnt(); //quantidade de items vcisiveis na tabela
tableBasicRecentes(); //ordena por id maior ou menor
FilepondCardsCreatorWrapper(); //coloca no window a funçao de criaro card do filepond

initMenuMobile();
mutationForm(); //valida se os selects obrigatorios estao preenchidos
submitOnChange();
inputLogin();
dataMasks();
initConditionalLink();

// const menu = multiLevelMenu(subMenuItens).init()

// window.menu = menu
// window.modalFiltrar = modalFiltrar
// console.log(modalFiltrar)

document.addEventListener("DOMContentLoaded", () =>
	document.body.classList.add("DOMContentLoaded")
);
